import { OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { useAccountingStatus, useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltySuccess } from '@/Logalty/ui/molecules'
import { currency } from '@/Shared/domain'

export const Step4Success = (): JSX.Element => {
  const { t } = useTranslation()
  const {
    logalty: { signStatus },
    navigateToOrigin,
  } = useBankAccount()
  const { accountingStatus, clearDebt } = useAccountingStatus()

  const handleOnClick = async (): Promise<void> => {
    clearDebt().then(() => {
      navigateToOrigin()
    })
  }

  return (
    <LogaltySuccess
      title={t(contractTranslation.changeBankAccount.step4.status.ok.title)}
      description={t(contractTranslation.changeBankAccount.step4.status.ok.description)}
      extraDescription={
        accountingStatus.debtAmount > 0 ? (
          <OreText data-testid="debt" align="center" style={{ whiteSpace: 'pre-line' }}>
            {t(contractTranslation.changeBankAccount.step4.status.debt.description, {
              debt: currency(accountingStatus.debtAmount),
            })}
          </OreText>
        ) : undefined
      }
      buttonLabel={t(contractTranslation.changeBankAccount.step4.buttons.finish.label)}
      signStatus={signStatus}
      returnCallback={handleOnClick}
    />
  )
}
